import '../App.css';
import { useAppDispatch, useAppSelector } from '../slices/index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { faDeleteLeft } from '@fortawesome/free-solid-svg-icons';
import * as Quotes from '../slices/quotesSlice';

const SearchQuotes = () => {
	const dispatch = useAppDispatch();
	const quotesState = useAppSelector(state => state.quotes);

	return (
		<div style={{ display: 'flex', padding: 4, alignItems: 'center', fontSize: 16 }}>
			<div className="padding8">
				<FontAwesomeIcon icon={faMagnifyingGlass} />
			</div>
			<div className="flexGrow1" style={{ display: 'flex', alignItems: 'center' }}>
				<input placeholder='Search...' type="text" value={quotesState.searchStr} onChange={e => dispatch(Quotes.searchQuotes(e.target.value))} />
			</div>
			<div className="padding8" style={{cursor: 'pointer'}}>
				<FontAwesomeIcon icon={faDeleteLeft} onClick={() => dispatch(Quotes.searchQuotes(""))} />
			</div>
		</div>
	);
}

export default SearchQuotes;